import React, { Component } from 'react'
import { connect } from 'react-redux'
import history from 'browserHistory'
import { compose, withState } from 'recompose'

import { getRawViewState } from 'data'
import { selectors as NotesSelectors } from 'data/notes'
import { selectors as ConfigSelectors } from 'data/config'

import Button from 'components/base/Button'

import Title from './Title'
import ModalBody from 'components/Utils/Modal/Body'
import withGetApplicationShareSettings from 'components/Integrations/dataSync/withGetApplicationShareSettings'
import RoutesHelper from '../../../helpers/RoutesHelper'

class ShareToSlack extends Component {
  render() {
    const { note, viewState, onModalClose, clientId } = this.props
    const hasErrors = viewState.errors.size > 0

    return (
      <ModalBody>
        <Title note={note} hasIntegration={hasErrors === false} />
        <div className="flexbox margin-top-larger font-weight-medium flexbox-space-between">
          <Button.Secondary onClick={onModalClose}>Close</Button.Secondary>
          {hasErrors && (
            <Button.Primary
              onClick={() => {
                onModalClose()
                history.push(
                  RoutesHelper.settingsIntegrationApplicationDetails({
                    applicationId: clientId,
                  })
                )
              }}
            >
              Add Slack integration
            </Button.Primary>
          )}
        </div>
      </ModalBody>
    )
  }
}

const NotesShareToSlackConnected = compose(
  connect((state, { noteId }) => {
    const note = NotesSelectors.getNote(state, noteId)
    const viewState = getRawViewState(state, 'loadSlackChannels')

    return {
      note,
      viewState,
      clientId: ConfigSelectors.getSlackAppSliteClientId(state),
    }
  }),
  withState('channels', 'setChannels', []),
  withGetApplicationShareSettings({
    viewName: 'loadSlackChannels',
    onShareSettingsFetched: ({ setChannels }, { targets }) => {
      setChannels(targets[0].options)
    },
  })
)(ShareToSlack)

export default NotesShareToSlackConnected
